import CaseSides from './CaseSides';

export default CaseSides;
